import SensorPage from "./SensorPage";
export default SensorPage;
